export interface Brd {
    id: number;
    name: string;
}
export const brds: Brd[] = [
    { id: 1, name: "CNTT/DA09 - VẬT TƯ TIÊU HAO" },
    { id: 2, name: "CNTT/DA10 - QUẢN LÝ NHÂN SỰ" },
    { id: 3, name: "CNTT/DA11 - QUẢN LÝ TÀI SẢN" }
];